import { authRoles } from 'app/auth';

import AuthLayout from './AuthLayout';
import LoginForm from '../Login/components/LoginForm';
import ForgotPasswordForm from '../ForgotPassword/components/ForgotPasswordForm';
import ResetPasswordForm from '../ResetPassword/components/ResetPasswordForm';
import InvitationForm from '../Invitation/components/InvitationForm';

const AuthConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        topBanner: {
          display: false,
        },
        healtheraHeader: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      element: <AuthLayout />,
      children: [
        {
          path: 'login',
          element: <LoginForm />,
        },
        {
          path: 'forgot-password',
          element: <ForgotPasswordForm />,
        },
        {
          path: 'password-reset/:token',
          element: <ResetPasswordForm />,
        },
        {
          path: 'invitation/:inviteId',
          element: <InvitationForm />,
        },
      ],
    },
  ],
};

export default AuthConfig;
